import React from "react";
import {ADDRESS} from "../../../_api/client";

export default function Spinner() {
    const spinner = `${ADDRESS}/images/spinner.gif`

    const style = {
        position: "absolute",
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }

    const imgStyle = {
        width: "15em",
        height: "7em",
    }

    return (
        <div style={style}>
            <img style={imgStyle} src={spinner} alt="Загрузка..."/>
        </div>
    )
}